import ClipboardJS from 'clipboard';

const clipboard = new ClipboardJS('.rs-calc-gate__share-url');

const gateCopyMessage = document.querySelector<HTMLInputElement>(
	'.rs-calc-gate__share-url-message'
);

if (gateCopyMessage) {
	clipboard.on('success', function () {
		gateCopyMessage.innerHTML = 'URL Copied to Clipboard';
	});
}

const gateCloseButton = document.querySelector<HTMLElement>('.rs-calc-gate__close');

if (gateCloseButton) {
	gateCloseButton.addEventListener('click', function () {
		gateCloseButton.closest('.rs-calc-gate--active')?.classList.remove('rs-calc-gate--active');
	});
}
